// extracted by mini-css-extract-plugin
export default {"regWall":"DyMutuzw","mobile":"mobile","controls":"HKs2iXqc","control":"Qzx4NBg5","desktop":"desktop","title":"gqaGMXXC"};